module.exports = __webpack_public_path__ + "img/SingleLineContent.d6182129.svg";